export class Serializable {
  static toInstanceList(list = []) {
    return list.map((element) => new this(element));
  }

  serialize() {
    return this;
  }
}
